const MONTHS = [
    'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
    'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC',
];

// Figma의 "MAY 26" / "2025" 두 줄 표기용으로 날짜를 분해한다.
export function formatEventDateParts(dateString) {
    if (!dateString) return null;
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return null;
    return {
        monthDay: `${MONTHS[date.getMonth()]} ${date.getDate()}`,
        year: String(date.getFullYear()),
    };
}
